import React from 'react';
import Steeper from "../../../components/Steps/Steeper";
import NuevoSocio from './nuevoSocio';
import { EdicionSocioProvider, useEdicionSocio } from '../../../context/socio/use-edicion-socio';
import { usePersona } from '../../../context/persona';
import DireccionForm from './direccion/DireccionForm';
import ContactoForm from './contacto';
import ActividadEconomica from './actividadEconomica';
import { makeStyles } from "@mui/styles";

export const stepsSocioNuevo = [
  "Nuevo Socio",
  "Dirección",
  "Actividad Económica",
]

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const CreateInner = () => {
  const { infoPersona } = usePersona()
  const { activeStep } = useEdicionSocio()
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Steeper steps={stepsSocioNuevo} activeStep={activeStep} />
      {
        activeStep === 0 && (
          <NuevoSocio
            codigoSocioPreseleccionado={infoPersona.codigo}
          />
        )
      }
      {
        activeStep === 1 && (
          <DireccionForm />
        )
      }
      {/*     {
        activeStep === 2 && (
          <ContactoForm />
        )
      } */}
      {
        activeStep === 2 && (
          <ActividadEconomica />
        )
      }
    </div>
  );
}

const Create = (props) => (
  <EdicionSocioProvider>
    <CreateInner {...props} />
  </EdicionSocioProvider>
)

export default Create